import React, { useReducer } from 'react';

import { KeyboardArrowDown } from '@mui/icons-material';

import useBreadcrumbs from 'pages/Bulletin/hooks/use-breadcrumbs';
import isEmptyRecursive from 'utils/is-empty-recursive';

import Breadcrumbs from './components/Breadcrumbs';
import Description from './components/Description';
import Mentions from './components/Mentions';
import Published from './components/Published';
import Reporter from './components/Reporter';
import Source from './components/Source';
import Title from './components/Title';
import Type from './components/Type';
import ViewCount from './components/ViewCount';
import WebApplicability from './components/WebApplicability';
import useStyles from './styles';

interface Props {
    id: string;
    title: string;
    description: {
        short: string;
        full: string;
    };
    type: string;
    published?: string;
    reporter?: string;
    href?: string;
    viewCount?: number;
    webApplicable?: boolean;
    social: {
        reddit?: { counter: number };
        twitter?: { counter: number };
    };
    className?: string;
}

const Summary: React.FC<Props> = ({
    id,
    type,
    title,
    description,
    href,
    reporter,
    social,
    published,
    viewCount,
    webApplicable,
    className
}) => {
    const { classes, cx } = useStyles();

    const [expanded, toggleExpanded] = useReducer((value) => !value, false);
    const breadcrumbs = useBreadcrumbs({ id, type, title });

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.content}>
                <Breadcrumbs items={breadcrumbs} className={classes.breadcrumbs} />
                <Title title={title} />
                <div className={classes.info}>
                    {published ? <Published published={published} /> : null}
                    {reporter ? <Reporter reporter={reporter} /> : null}
                    {type ? <Type type={type} /> : null}
                    {href ? <Source href={href} /> : null}
                    {isEmptyRecursive(social) ? null : <Mentions social={social} />}
                    {viewCount ? <ViewCount viewCount={viewCount} /> : null}
                    {webApplicable ? <WebApplicability /> : null}
                </div>
                <Description short={description.short} full={description.full} expanded={expanded} />
            </div>
            <div className={classes.toggle} onClick={toggleExpanded}>
                {expanded ? 'Show less' : 'Show more'}
                <KeyboardArrowDown className={cx(classes.arrow, { [classes._expanded]: expanded })} />
            </div>
        </div>
    );
};

export default Summary;
